import apiClient from '@/plugins/axios';

export default {
	getMaps(searchParam) {
		var query = `?PageNumber=${searchParam.currentPage}&PageSize=${searchParam.pageSize}`;
		query += searchParam.orderBy ? `&OrderBy=${searchParam.orderBy}` : '';
		query += searchParam.floorId ? `&FloorId=${searchParam.floorId}` : '';
		query += searchParam.level ? `&Level=${searchParam.level}` : '';

		return apiClient.get(`v1/Map${query}`);
	},

	getMap(mapId) {
		return apiClient.get(`v1/Map/${mapId}`);
	},

	createMap(map) {
		return apiClient.post('v1/Map', map);
	},

	updateMap(map) {
		var mapId = map.id;

		return apiClient.put(`v1/Map/${mapId}`, map);
	},

	deleteMap(mapId) {
		return apiClient.delete(`v1/Map/${mapId}`);
	}
};
